<template>
    <div>
        <div class="col-sm-12">
            <div>
                <div class="form-group row">
                    <label class="col-sm-1 text-nowrap" style="min-width: 180px">{{ $t('landingPage.settingReceiptPhotography.title') }} </label>
                    <div class="col-sm-10">
                        <Editor
                            v-if="isVisibleEditor"
                            :id="`editorStyleReceipt`"
                            :isBackgroundImageEditor="false"
                            :model.sync="dataForm.block_receipt_photography_tutorial.html_content"
                            :modelEvents="`change keydown blur focus paste`"
                            :configInit="configEditor"
                            @init="onEditorInit"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Editor from '@/components/Editor/main.vue';

export default {
    name: 'SettingReceiptPhotography',
    components: {
        Editor
    },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {
            isVisibleEditor: false,
            objEditor: null,
            configEditor: {
                height: '100vh'
            }
        };
    },
    methods: {
        onEditorInit(editor) {
            this.objEditor = editor;
        }
    },
    mounted() {
        setTimeout(() => {
            this.isVisibleEditor = true;
        }, 300);
    }
};
</script>

<style lang="scss" scoped></style>
